import React from "react";
import { Eye, Trash2 } from "react-feather";

export class TableModule extends React.Component {
    constructor(props) {
        super(props);
        this.logger = window.BaseLogger;

        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onRowSelected = this.onRowSelected.bind(this);
    }

    getColumnTitle(id) {
        var metaData = this.props.metaData[id];
        var display = metaData.display;
        if (display) {
            if (!display.columnSizeId || display.columnSizeId == 0) {
                return null;
            }

            if (display.caption) {
                return display.caption;
            }
        }
        return null;
    }

    getColumnWidth(id) {
        var metaData = this.props.metaData[id];
        var display = metaData.display;
        if (display) {
            if (!display.columnSizeId || display.columnSizeId == 0) {
                return 0;
            }
            return display.columnSizeId;
        }
        return 0;
    }

    onDeleteClick(e) {
        console.log("delete click processed");
        e.stopPropagation();
        var item = JSON.parse(e.currentTarget.dataset.item);
        if (this.props.onDeleting) {
            this.props.onDeleting(item);
        }
    }

    onRowSelected(event) {
        var item = JSON.parse(event.currentTarget.dataset.item);
        if (this.props.onRowSelected) {
            this.props.onRowSelected(item);
        }
    }

    render() {
        var self = this;
        return (
            <div className="table">
                <div className="table-header">
                    {Object.keys(self.props.metaData).map(function (controlId, index) {
                        var title = self.getColumnTitle(controlId);
                        if (title) {
                            return (
                                <div className="header-col" key={"header_" + index}>
                                    <span>{title}</span>
                                </div>
                            );
                        }
                    })}
                    <div className="header-col-actions">
                        <span>Actions</span>
                    </div>
                </div>

                {self.props.items.map(function (item, index1) {
                    // <div className="" key={'row_' + index1}>

                    return (
                        <div
                            key={`row_${index1}`}
                            className="table-row"
                            data-item={JSON.stringify(item)}
                            onClick={self.onRowSelected}
                        >
                            {Object.keys(self.props.metaData).map(function (controlId, index2) {
                                var title = self.getColumnTitle(controlId);
                                if (title) {
                                    return (
                                        <div
                                            className="row-col"
                                            // {
                                            //     "" +
                                            //     self.getColumnWidth(controlId) +
                                            //     " " +
                                            //     self.getColumnWidth(controlId)
                                            // }
                                            key={"row_" + index1 + "_" + index2}
                                        >
                                            <span>{item[controlId]}</span>
                                        </div>
                                    );
                                }
                            })}
                            <div className="row-col-actions">
                                {/* <button className='btn btn-danger' onClick={self.onDeleteClick} data-item={JSON.stringify(item)} disabled={self.props.enableDelete == false}><span className='glyphicon glyphicon-trash'></span></button>
                                    <button className='btn btn-success' onClick={self.onRowSelected} data-item={JSON.stringify(item)}><span className='glyphicon glyphicon-eye-open'></span></button> */}
                                <Trash2 onClick={self.onDeleteClick} data-item={JSON.stringify(item)} />
                            </div>
                        </div>
                        // </div>
                    );
                })}
            </div>
        );
    }
}
